import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { REQUEST_TYPE_CONFIG, RequestType } from '../../../../core/types';
import { getThemes, supportQueryKeys } from '../../api';
import { SelectOption } from '../../types/option';

export type UseThemeOptionsResult = {
  options: SelectOption[];
  loading: boolean;
  error: string | undefined;
};

export function useThemeOptions(type: RequestType): UseThemeOptionsResult {
  const { data, isLoading, isError } = useQuery({
    queryKey: supportQueryKeys.themes,
    queryFn: ({ signal }) => getThemes(signal),
  });

  const options = useMemo(() => {
    const category = REQUEST_TYPE_CONFIG[type].value;

    return (data ?? [])
      .filter((theme) => theme.allowAllCategories || theme.categories.includes(category))
      .map(({ id, label }) => ({ id, label }));
  }, [data, type]);

  return {
    options,
    loading: isLoading,
    error: isError ? 'Não foi possível carregar os temas' : undefined,
  };
}
